import React, { useContext, useState } from "react"
import BoxComponent from "../../../Box/BoxComponent"
import ButtonComponent from "../../../Button/ButtonComponent";
import ConfigIcon from "../../../../assets/icons/dashboard/config.png";
import ImageLogoComponent from "../../../Image/ImageLogoComponent";
import { ReactComponent as SinoIcon } from "../../../../assets/icons/dashboard/sino_notificacao.svg";
import TypographyComponent from "../../../Typography/ThypographyComponent";
import SvgComponent from "../../../Image/SvgComponent";
import { Popover } from "@mui/material";
import { AuthContext } from "../../../../provider/auth/AuthContext";
import { useNavigate } from "react-router-dom";
import PopoverHeaderComponent from "./PopoverHeaderComponent";

const DashboardHeaderComponent = () => {
    const [qtdNotificacoes, setQtdNotificacoes] = useState<number>(0);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const { usuario, logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleClickNotificacao = () => {
        setQtdNotificacoes(qtdNotificacoes + 1);
    }

    const handleClickConfiguracao = (
        event: React.MouseEvent<HTMLElement>
    ) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseConfiguracao = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const handleLogout = async () => {
        const path = window.location.pathname;
        const slug = path.split("/")[1];
        navigate(`../${slug}/login`);
    }

    return <BoxComponent
        sx={{
            display: "flex",
            alignItems: 'center',
            justifyContent: 'flex-end',
            height: 64,
            opacity: 1,
            transform: 'rotate(0deg)',
            pr: '32px',
            boxSizing: 'border-box',
            background: 'linear-gradient(90deg, #FFFFFF 0%, #F8F5F0 100%)',
            borderBottom: '0.8px solid var(--color-orange-87, #E8DFD5)',
            boxShadow: '0px 2px 8px 0px rgba(61, 40, 23, 0.08)',
            gap: 1.2
        }}
        component="header">
        <ButtonComponent
            id="notificacoes"
            sx={{
                minWidth: 40,
                minHeight: 40,
                transform: 'rotate(0deg)',
                borderRadius: "8px"
            }}
            onClick={handleClickNotificacao}
        >
            <SvgComponent
                icon={<SinoIcon />}
                sx={{
                    display: "flex",
                    alignpropss: "center",
                    justifyContent: "center",
                    "& svg, & svg *": {
                        // fill: "#EF4444",
                        stroke: "#6A7282",
                    },
                }}
            />

            {qtdNotificacoes > 0 && (
                <TypographyComponent
                    variant="body2"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "absolute",
                        top: 5,
                        right: 5,
                        width: 21,
                        height: 21,
                        // angle: 0 deg,
                        // opacity: 1,
                        borderRadius: "50%",
                        background: "#FF4444",
                        color: "#fff"
                    }}
                >
                    {qtdNotificacoes}
                </TypographyComponent>
            )}
        </ButtonComponent>
        <ButtonComponent
            id="config"
            sx={{
                minWidth: 40,
                minHeight: 40,
                transform: 'rotate(0deg)',
                borderRadius: "8px"
            }}
            onClick={handleClickConfiguracao}
        >
            <ImageLogoComponent
                sx={{
                    width: 20,
                    height: 20,
                    borderRadius: 0
                }}
                src={ConfigIcon}
                alt="config_header"
            />
        </ButtonComponent>

        <PopoverHeaderComponent 
            open={open}
            anchorEl={anchorEl}
            nome={usuario?.nome}
            telefone={usuario?.telefoneCompleto}
            cargo={usuario?.cargo}
            onClosePopover={handleCloseConfiguracao}
            onClickLogout={handleLogout}
        />
    </BoxComponent >
}

export default DashboardHeaderComponent;